<!--CUSTOM IDS-104: New auth page both login and registration-->
<script setup lang="ts">
const customerStore = useCustomerStore();
const { signedIn } = storeToRefs(customerStore);
const { t } = useI18n();
</script>

<template>
    <div class="container flex min-h-screen w-full flex-col items-start gap-6 p-10 md:flex-row md:p-0">
        <div class="w-full md:w-[40%] lg:pr-28">
            <h2 class="non-italic mb-4 text-left text-3xl font-extrabold">{{ t('account.login.title') }}</h2>
            <AccountLogin :redirect-after-success="true" />
        </div>

        <div class="w-full md:w-[60%]">
            <h2 class="non-italic mb-4 text-left text-3xl font-extrabold">{{ t('account.register.title') }}</h2>
            <AccountRegister :redirect-after-success="true" />
        </div>
        <div v-show="signedIn">
            <div class="absolute inset-0 flex items-center justify-center bg-white/50 backdrop-blur-sm">
                <UtilityLoadingSpinner />
            </div>
        </div>
    </div>
</template>
